<template>
  <div class="mt-4 px-md-4">
    <div v-if="isLoading" class="text-center">
      <hr class="space space-sm">
      <loader size="128px"></loader>
      <p class="small muted pt-4">One moment...</p>
    </div>
    <div v-else-if="documents && documents.length">
      <div
        v-for="doc in documents"
        :key="doc.id"
        class="d-flex mb-4"
      >
        <div>
          <div class="img-round">
            <img v-if="doc.kind == 'figma'" src="/static/images/icons/document_figma.png">
            <img v-else-if="doc.kind == 'zip'" src="/static/images/icons/document_zip.png">
            <div class="placeholder bg-primary regular smaller" v-else>
              <template v-if="doc.kind == 'other'">...</template>
              <template v-else>{{ doc.kind.toUpperCase() }}</template>
            </div>
          </div>
        </div>
        <div class="flex-grow-1 pl-2">
          <h6 class="medium mb-0">{{ doc.title }}</h6>
          <p class="small muted mb-0">{{ doc.published | moment("D MMMM YYYY") }}</p>
          <p class="small lh15">
            <a :href="doc.url">{{ doc.url }}</a>
          </p>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <img src="/static/images/icons/documents_empty.svg" alt="">
      <p class="regular pt-4">No docs uploaded</p>
      <p class="lh15 small">
        It seems we are at the very start of our project, so this tab is currently empty.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'dashboard-documents',
  props: ['id'],
  data () {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      project: state => state.projects.current,
      documents: state => state.projects.documents
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('LOAD_PROJECT_DOCUMENTS', this.id)
      .then((response) => {
        this.isLoading = false
      })
    if (!this.project || !this.project.id === this.id) {
      this.$store.dispatch('LOAD_PROJECT_BY_ID', this.id)
    } else {
      this.isLoading = this.documents && this.documents.length > 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
